import React, { FC, useEffect } from 'react'
import { ConnectedProps, connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import SettingsSidebar from '../components/SettingsSidebar'

import { FormInputRadio, PageLayout } from 'Components'
import { CoreBackendUserReduxType, ReduxStoreState } from 'Models'
import { DEFAULT_GLASS_SIZE } from 'Pages/JournalPage/components/JournalCardHydrationContainer/JournalCardHydrationContainer'
import { coreBackendUserSelector, fetchCoreBackendUserAction } from 'ReduxStore/coreBackendUser'
import { useAppDispatch, useAppSelector } from 'ReduxStore/hooks'
import { updateUserSettingsAction } from 'ReduxStore/userSettings'

type SelectorProps = {
  coreBackendUser: CoreBackendUserReduxType
}

const mapStateToProps = createStructuredSelector<ReduxStoreState, SelectorProps>({
  coreBackendUser: coreBackendUserSelector
})

const mapDispatchToProps = {
  fetchCoreBackendUser: fetchCoreBackendUserAction
}

const connector = connect(mapStateToProps, mapDispatchToProps)

type PropsFromRedux = ConnectedProps<typeof connector>

const glassSizes = [100, 250, 330, 500, 750, 1000]

const glassSizeOptions = glassSizes.map((size) => ({
  value: size,
  label: size === 1000 ? `1 l` : `${size / 100} dl`
}))

const HydrationSettingsPage: FC<PropsFromRedux> = ({ fetchCoreBackendUser }: PropsFromRedux) => {
  const userSettings = useAppSelector((state) => state.userSettings)

  const dispatch = useAppDispatch()

  const handleGlassSizeSelection = (size: number): void => {
    dispatch(updateUserSettingsAction({ hydrationGlassSize: size }))
  }

  useEffect(() => {
    fetchCoreBackendUser()
  }, [])

  return (
    <PageLayout variant="smallcircle">
      <div className="container max-900">
        <div className="row">
          <SettingsSidebar />

          <div className="col-12 col-lg-8">
            <h1>Einstellungen</h1>

            <h2 className="mt-4">Flüssigkeitszufuhr</h2>

            <div className="basiccard p-3 mt-3">
              <p>Wählen Sie die Standard-Glasgrösse:</p>

              <div className="mt-3">
                <FormInputRadio
                  name="hydrationGlassSize"
                  items={glassSizeOptions}
                  onChange={(size) => handleGlassSizeSelection(size.value)}
                  selectedKey={String((userSettings.data.hydrationGlassSize as number) ?? DEFAULT_GLASS_SIZE)}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </PageLayout>
  )
}

export default connector(HydrationSettingsPage)
